import React from "react";

// actions: [{ icon, iconBg, label, sublabel, onClick }]
const QuickActionsPanel = ({ actions = [] }) => {
  return (
    <div
      style={{
        borderRadius: "14px",
        border: "1px solid #E3EBF8",
        background: "#fff",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        // Matches the height: "100%" the Revenue Overview and Status Donut
        // cards set on their own wrappers — without it this card sat
        // shorter than them (its content is naturally less tall), leaving
        // a visible height mismatch in the row.
        height: "100%",
        boxSizing: "border-box",
      }}
    >
      <div style={{ fontSize: "15px", fontWeight: 600, color: "#111827", marginBottom: "8px" }}>
        Quick Actions
      </div>
      {actions.map((a, i) => (
        <div
          key={i}
          onClick={a.onClick}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "10px 8px",
            borderRadius: "10px",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#F9FAFB")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: "10px",
              background: a.iconBg || "#FDEDED",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {a.icon}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: "13.5px", fontWeight: 600, color: "#111827" }}>{a.label}</div>
            <div style={{ fontSize: "12px", color: "#6B7280" }}>{a.sublabel}</div>
          </div>
          <span style={{ color: "#9CA3AF", fontSize: "16px" }}>›</span>
        </div>
      ))}
    </div>
  );
};

export default QuickActionsPanel;
